<template>
    <section id="sectionFooter" class="checkout-section transparent">
        <privacy-consent-info/>
        <div class="section-row">
            <component v-bind:is="buttonType"/>
        </div>
        <div class="checkout-row">
            <send-checkout-link-button/>
        </div>
    </section>
</template>

<script src='./place-order-block.js'></script>
